import React from 'react';
import StartEndInputs from 'UI/Inputs/StartEndInputs';

/**
 * StartEndFieldEditor
 * Props:
 * - field: the field object from template
 * - index: position index
 * - controls: JSX for the field controls (move/remove)
 * - labels: optional labels object { startLabel, endLabel }
 */
const StartEndFieldEditor = (props) => {
	const { field, index, controls, onPlaceholderChange, labels, disabled } = props;
	let parsed = { start: '', end: '', labels: labels || { startLabel: 'Start Date', endLabel: 'End Date' } };
	try {
		const p = JSON.parse(field.placeholder || '{}');
		if (p) parsed = { ...parsed, ...p };
		if (!parsed.labels) parsed.labels = labels || { startLabel: 'Start Date', endLabel: 'End Date' };
	} catch (e) {
		// keep defaults
	}

	const handleTimesChange = (v) => {
		const next = { ...parsed, start: v.start || '', end: v.end || '' };
		if (typeof onPlaceholderChange === 'function') {
			onPlaceholderChange(index, next);
		}
	};


	return (
		<div className="start-end-inputs">
			<div style={{ marginBottom: '0.85rem' }}>
				<div style={{ marginBottom: '.2rem' }}>
					<div style={{ float: 'right' }}>
						{controls}
					</div>
					<div className="clearfix" />
				</div>

				<StartEndInputs
					value={{ start: parsed.start, end: parsed.end }}
					onChange={handleTimesChange}
					labels={parsed.labels}
					disabled={disabled}
				/>
			</div>
		</div>
	);
};

export default StartEndFieldEditor;
